import { Field } from "formik";
import React from "react";
import { STRING_CONSTANT } from "../../constants/constants";
import { t } from "i18next";

const FormSelectField = (props) => {
  const {
    label,
    options,
    fieldName,
    error,
    touched,
    isRequired,
    className,
    handleChange,
  } = props;

  return (
    <div className={className}>
      <label htmlFor={fieldName} className="form-label">
        {label}
        {isRequired && (
          <span className="text-danger">{STRING_CONSTANT.SPACE}*</span>
        )}
      </label>
      <Field
        as="select"
        className="form-select"
        id={fieldName}
        name={fieldName}
        onChange={handleChange}
      >
        <option value={STRING_CONSTANT.BLANK} disabled={true}>{t("select")}</option>
        {options.map((item) => (
          <option key={item.key} value={item.key}>
            {item.name}
          </option>
        ))}
      </Field>
      {error && touched ? (
        <div className="text-danger">{error}</div>
      ) : (
        STRING_CONSTANT.BLANK
      )}
    </div>
  );
};

export default FormSelectField;
